import { DOLLAR_SIGN } from '../GridDndEditor/Block/Table/defaultData.tsx';

export const formatCurrencyValue = (value: number, locale = 'en-US', currency = DOLLAR_SIGN): string => {
  const formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
  }).format(value);
  return `${currency}${formattedNumber}`;
};
